module.exports = __webpack_public_path__ + "img/FLogo.0020ac82.webp";